import { Box, Heading, List, Text } from '@chakra-ui/react';
import {
	AiFillClockCircle,
	AiFillSetting,
	AiFillTags,
	AiOutlineDesktop,
} from 'react-icons/ai';
import { FaGlobe } from 'react-icons/fa';
import { useT } from '@/i18n/useLanguage';
import GameInfoItem from './GameInfoItem';

interface Game {
	platforms?: { platform: { name: string } }[];
	developers?: { name: string }[];
	genres?: { name: string }[];
	publishers?: { name: string }[];
	released?: string;
	description_raw?: string;
}

const GameDetails = ({ game }: { game?: Game }) => {
	const t = useT();
	const platforms = game?.platforms?.map((p) => p.platform.name);
	const developers = game?.developers?.map((d) => d.name);
	const genres = game?.genres?.map((g) => g.name);
	const publishers = game?.publishers?.map((p) => p.name);

	const details = [
		{ icon: AiFillClockCircle, label: t('releaseDateLabel'), value: game?.released },
		{ icon: AiOutlineDesktop, label: t('platforms'), value: platforms?.join(', ') },
		{ icon: AiFillSetting, label: t('developers'), value: developers?.join(', ') },
		{ icon: AiFillTags, label: t('genres'), value: genres?.join(', ') },
		{ icon: FaGlobe, label: t('publishers'), value: publishers?.join(', ') },
	];

	const desc = game?.description_raw
		? game.description_raw.split('.').slice(0, 3).join('.') + '.'
		: '';

	return (
		<Box mt={{ base: '24px', lg: '0' }}>
			<Heading as="h4" size="md" mb="3" textTransform="uppercase">
				<Text as="span" color="brand.400">
					{t('game')}
				</Text>{' '}
				<Text as="span">{t('details')}</Text>
			</Heading>

			{desc && (
				<Text fontWeight="200" opacity="0.9">
					{desc}
				</Text>
			)}

			<List.Root gap="4" mt="6" as="ol">
				{details.map((item, idx) => (
					<GameInfoItem
						key={idx}
						icon={item.icon}
						label={item.label}
						value={item.value ?? ''}
					/>
				))}
			</List.Root>
		</Box>
	);
};

export default GameDetails;
